// extracted by mini-css-extract-plugin
module.exports = {"fashionAssistantLook":"FashionAssistantLook_fashionAssistantLook__10nZl","image":"FashionAssistantLook_image__gJfSp"};